import { render, staticRenderFns } from "./UnidadeFederativaAdicionar.vue?vue&type=template&id=48328743"
import script from "./UnidadeFederativaAdicionar.vue?vue&type=script&lang=js"
export * from "./UnidadeFederativaAdicionar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports